module.exports = __webpack_public_path__ + "static/media/ExpenseTracker.a0dfd2fd.svg";